"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOOLBAR_CONTROL_TYPES = exports.apiProxyWhitelist = exports.lineHeightsList = exports.fontSizeList = exports.fontFormatList = exports.HS_PERSONALIZE_NEW_PLUGIN_GATE = exports.HS_MEDIA_URL_PASTING_GATE = exports.HS_VIDEO_NEW_PLUGIN_GATE = exports.HS_NEWLINE_PLUGIN_GATE = exports.MEETING_LINK_GATE = exports.KNOWLEDGE_BASE_CALLOUTS_PLUGIN_GATE = exports.KNOWLEDGE_BASE_TABLES_GATE = exports.PROPAGATION_OVERRIDE_GATE = exports.WORKFLOWS_CANVAS_TOOLBAR_GATE = exports.HSPROTECT_GATE = exports.HS_ANCHOR_NEW_PLUGIN_GATE = exports.HS_MEDIA_NEW_PLUGIN_GATE = exports.CRM_SCOPE = exports.HSCTA_SCOPE = exports.HSVIDEO_SCOPE = exports.SUPPORTED_LANGS = void 0;

var _constants = require("rich-text-lib/api/constants");

var SUPPORTED_LANGS = ['de', 'es', 'ja', 'pt', 'fr']; // Gates and scopes

exports.SUPPORTED_LANGS = SUPPORTED_LANGS;
var HSVIDEO_SCOPE = 'marketing-video';
exports.HSVIDEO_SCOPE = HSVIDEO_SCOPE;
var HSCTA_SCOPE = 'cta-access';
exports.HSCTA_SCOPE = HSCTA_SCOPE;
var CRM_SCOPE = 'crm-product';
exports.CRM_SCOPE = CRM_SCOPE;
var HS_MEDIA_NEW_PLUGIN_GATE = 'tinymce_new_embed_plugin';
exports.HS_MEDIA_NEW_PLUGIN_GATE = HS_MEDIA_NEW_PLUGIN_GATE;
var HS_ANCHOR_NEW_PLUGIN_GATE = 'tinymce_new_anchor_plugin';
exports.HS_ANCHOR_NEW_PLUGIN_GATE = HS_ANCHOR_NEW_PLUGIN_GATE;
var HSPROTECT_GATE = 'tinymce_xss_protect_plugin';
exports.HSPROTECT_GATE = HSPROTECT_GATE;
var WORKFLOWS_CANVAS_TOOLBAR_GATE = 'tinymce_workflows_canvas_toolbar';
exports.WORKFLOWS_CANVAS_TOOLBAR_GATE = WORKFLOWS_CANVAS_TOOLBAR_GATE;
var PROPAGATION_OVERRIDE_GATE = 'tinymce_propagation_override';
exports.PROPAGATION_OVERRIDE_GATE = PROPAGATION_OVERRIDE_GATE;
var KNOWLEDGE_BASE_TABLES_GATE = 'KnowledgeContent:TinyMCETables';
exports.KNOWLEDGE_BASE_TABLES_GATE = KNOWLEDGE_BASE_TABLES_GATE;
var KNOWLEDGE_BASE_CALLOUTS_PLUGIN_GATE = 'KnowledgeContent:CalloutsPlugin';
exports.KNOWLEDGE_BASE_CALLOUTS_PLUGIN_GATE = KNOWLEDGE_BASE_CALLOUTS_PLUGIN_GATE;
var MEETING_LINK_GATE = 'tinymce_meeting_link';
exports.MEETING_LINK_GATE = MEETING_LINK_GATE;
var HS_NEWLINE_PLUGIN_GATE = 'tinymce_newline_plugin';
exports.HS_NEWLINE_PLUGIN_GATE = HS_NEWLINE_PLUGIN_GATE;
var HS_VIDEO_NEW_PLUGIN_GATE = 'tinymce_new_video_plugin';
exports.HS_VIDEO_NEW_PLUGIN_GATE = HS_VIDEO_NEW_PLUGIN_GATE;
var HS_MEDIA_URL_PASTING_GATE = 'tinymce_embed_url_pasting';
exports.HS_MEDIA_URL_PASTING_GATE = HS_MEDIA_URL_PASTING_GATE;
var HS_PERSONALIZE_NEW_PLUGIN_GATE = 'tinymce_new_personalize';
exports.HS_PERSONALIZE_NEW_PLUGIN_GATE = HS_PERSONALIZE_NEW_PLUGIN_GATE;
var fontFormatList = {
  'Andale Mono': '"andale mono", times',
  Arial: 'arial, helvetica, sans-serif',
  'Book Antiqua': '"book antiqua", palatino',
  'Courier New': '"courier new", courier',
  Georgia: 'georgia, palatino',
  Helvetica: 'helvetica',
  Impact: 'impact, chicago',
  Symbol: 'symbol',
  Tahoma: 'tahoma, arial, helvetica, sans-serif',
  Terminal: 'terminal, monaco',
  'Times New Roman': '"times new roman", times',
  'Trebuchet MS': '"trebuchet ms", geneva',
  Verdana: 'verdana, geneva'
};
exports.fontFormatList = fontFormatList;
var fontSizeList = ['8', '9', '10', '11', '12', '13', '14', '15', '16', '18', '20', '24', '30', '36', '48', '60', '72'];
exports.fontSizeList = fontSizeList;
var lineHeightsList = [1, 1.15, 1.25, 1.5, 1.75, 2, 2.5, 3, 4]; // API white list

exports.lineHeightsList = lineHeightsList;
var apiProxyWhitelist = Object.keys(_constants.ApiMap).map(function (key) {
  return {
    regex: _constants.ApiMap[key].regex,
    methods: _constants.ApiMap[key].methods
  };
});
exports.apiProxyWhitelist = apiProxyWhitelist;
var TOOLBAR_CONTROL_TYPES = {
  BUTTON: 'BUTTON',
  SELECT: 'SELECT',
  DIVIDER: 'DIVIDER',
  MORE_MENU: 'MORE_MENU',
  ADVANCED_MENU: 'ADVANCED_MENU',
  INSERT_MENU: 'INSERT_MENU'
};
exports.TOOLBAR_CONTROL_TYPES = TOOLBAR_CONTROL_TYPES;